import { render, staticRenderFns } from "./ContactEditModal.vue?vue&type=template&id=4bb781ca"
import script from "./ContactEditModal.vue?vue&type=script&lang=ts"
export * from "./ContactEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports